import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {CardComponent} from "./card.component";
import {ContentModule} from "../../../../shared/directives/content.module";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {ButtonModule} from "../button/button.module";
import {FormFieldModule} from '../form-field/form-field.module';
import {MatExpansionModule} from "@angular/material/expansion";
import {
    ConsultationListCardModule
} from "../../../medical/consultation/consultation/api/component/consultation-list-card/consultation-list-card.module";
import {MatCardModule} from "@angular/material/card";
import {MatBadgeModule} from "@angular/material/badge";
import {MatIconModule} from "@angular/material/icon";
import {TablerIconsModule} from "angular-tabler-icons";
import {ExpandableContentModule} from "../expandable-content/expandable-content.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ContentModule,
        LoadingModule,
        ButtonModule,
        FormFieldModule,
        MatExpansionModule,
        MatCardModule,
        MatBadgeModule,
        MatIconModule,
        TablerIconsModule,
        ExpandableContentModule,
    ],
    declarations: [
        CardComponent,
    ],
    exports: [
        CardComponent,
        ContentModule
    ],
})
export class CardModule {}